import { createAction } from "@reduxjs/toolkit";

import type { NodeDesignsRevision } from "../../schemas/index.ts";
import { withPayloadType } from "./actionHelpers.ts";

export const applyRevisionServerAction = createAction("APPLY_REVISION", withPayloadType<NodeDesignsRevision>());

export type ApplyRevisionServerAction = ReturnType<typeof applyRevisionServerAction>;

export const undoRevisionServerAction = createAction("UNDO_REVISION", withPayloadType<{ revision: number }>());

export type UndoRevisionServerAction = ReturnType<typeof undoRevisionServerAction>;

export const redoRevisionServerAction = createAction("REDO_REVISION", withPayloadType<{ revision: number }>());

export type RedoRevisionServerAction = ReturnType<typeof redoRevisionServerAction>;

export type ServerAction = ApplyRevisionServerAction | UndoRevisionServerAction | RedoRevisionServerAction;

export type SendActionToServer = (action: ServerAction, opts: { signal?: AbortSignal }) => Promise<void>;
